/**
 * Allow the text in simple-share-button-adder to be changed, a feature the plugin does not allow
 * by default.
 */

/**
 * Change the text above the share button
 *
 * @param newText  The text to add above the buttons. Defaults to the translation of 'Share'
 *                 sent in thru wpml localization object
 */
const changeShareText = ( newText = '' ) => {
    if ( '' === newText ) {
        newText = sharebar.share_text;
    }

    const shareTextElements = document.getElementsByClassName('ssba-share-text');
    console.log( shareTextElements );

    if( shareTextElements ) {
        for ( const shareText of shareTextElements) {
            shareText.innerHTML = newText;
        }

    }
}

changeShareText();